import {FormikProps} from 'formik';
import {PaymentAddress} from '../../../interfaces/payment-address';
import {Form, Row} from 'react-bootstrap';
import TextInputControlled from '../../../modules/form/TextInputControlled';
import {useIntl} from 'react-intl';
import {CustomerSystem} from "../../../../Domains/Auth/Types/customer";

interface PaymentAddressFormProps {
    formik: FormikProps<PaymentAddress>;
    system: CustomerSystem;
}

const PaymentAddressForm = ({system, formik}: PaymentAddressFormProps): JSX.Element => {
    const intl = useIntl();
    return (
        <Form onSubmit={formik.handleSubmit}>
            <Row className="my-5">
                <TextInputControlled
                    name="address"
                    value={formik.values.address}
                    label={intl.formatMessage({
                        id: 'ADMINISTRATIVE.PAYMENT_ADDRESS_EDIT_MODAL.ADDRESS_LABEL',
                    })}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onReset={formik.handleReset}
                    errors={formik.errors['address']}
                    touched={formik.touched['address']}
                    maxLength={90}
                />
            </Row>
            <Row className="my-5">
                <TextInputControlled
                    name="zipCode"
                    value={formik.values.zipCode}
                    label={intl.formatMessage({
                        id: 'ADMINISTRATIVE.PAYMENT_ADDRESS_EDIT_MODAL.ZIP_CODE_LABEL',
                    })}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onReset={formik.handleReset}
                    errors={formik.errors['zipCode']}
                    touched={formik.touched['zipCode']}
                    maxLength={system === CustomerSystem.CIS ? 30 : 5}
                />
            </Row>
            <Row className="my-5">
                <TextInputControlled
                    name="city"
                    value={formik.values.city}
                    label={intl.formatMessage({
                        id: 'ADMINISTRATIVE.PAYMENT_ADDRESS_EDIT_MODAL.CITY_LABEL',
                    })}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onReset={formik.handleReset}
                    errors={formik.errors['city']}
                    touched={formik.touched['city']}
                    maxLength={60}
                />
            </Row>
            <Row className="my-5">
                <TextInputControlled
                    name="country"
                    value={formik.values.country ?? ''}
                    label={intl.formatMessage({
                        id: 'ADMINISTRATIVE.PAYMENT_ADDRESS_EDIT_MODAL.COUNTRY_LABEL',
                    })}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onReset={formik.handleReset}
                    errors={formik.errors['country']}
                    touched={formik.touched['country']}
                    maxLength={35}
                />
            </Row>
        </Form>
    );
};

export default PaymentAddressForm;
